<div class="p-8 md:py-14 md:mb-8 md:bg-white relative">
  <h2
    class="
      z-10
      relative
      text-5xl
      mb-8
      md:mb-0 md:mx-auto md:max-w-5xl
      text-center
      te-text-gradient
      font-secondary font-normal
    "
  >
    {{ 'modules.evcSmallBiz.productOverview.pageTitle' | translate }}
  </h2>
  <img
    class="hidden md:block z-0 h-full absolute right-0 top-0"
    src="./assets/evsb/img/charging-car.png"
    alt="charging car"
  />
</div>
<div class="p-8 container mx-auto max-w-7xl xl:max-w-screen-xl w-full" *ngIf="model$ | async as model">
  <p class="text-grey-dark text-center mb-8 uppercase">
    {{ 'modules.evcSmallBiz.productOverview.chargingSolutionsTitle' | translate }}
  </p>

  <div class="flex flex-col xl:flex-row xl:justify-center xl:gap-x-16 xl:items-start">
    <evsb-card [variant]="'turquoise'" class="mb-12 w-full">
      <evsb-card-header-image
        [variant]="'turquoise'"
        [label]="'modules.evcSmallBiz.productOverview.greenEnergy.title' | translate"
      >
      </evsb-card-header-image>
      <evsb-card-body class="border-b border-grey block">
        <ul class="list-checkmark space-y-2">
          <li
            class="mb-3"
            [innerHtml]="'modules.evcSmallBiz.productOverview.greenEnergy.point1.title' | translate"
          ></li>
          <li
            class="mb-3"
            [innerHtml]="'modules.evcSmallBiz.productOverview.greenEnergy.point2.title' | translate"
          ></li>
        </ul>
      </evsb-card-body>
      <evsb-card-body>
        <div class="flex justify-between">
          <div class="self-center">
            <div class="flex items-center bg-appleblue rounded-lg px-3">
              <div class="align-baseline text-sm text-grey-dark">
                <span class="font-bold uppercase">
                  {{ 'modules.evcSmallBiz.productOverview.greenEnergy.save' | translate }}
                </span>
              </div>
            </div>
            <!-- mobile size -->
            <div class="md:hidden body-mention text-grey-dark60">
              {{ 'modules.evcSmallBiz.productOverview.greenEnergy.onYourInvoice' | translate }}
            </div>
            <!-- desktop size -->
            <div class="hidden md:block body-small text-grey-dark60">
              {{ 'modules.evcSmallBiz.productOverview.greenEnergy.onYourInvoice' | translate }}
            </div>
          </div>

          <evsb-secondary-button [size]="btnSmall" class="text-xl" (click)="onSimulateGreenEnergy()">
            {{ 'modules.evcSmallBiz.productOverview.greenEnergy.cta' | translate }}
            <svg-icon end src="./assets/evc/img/external.svg"></svg-icon>
          </evsb-secondary-button>
        </div>
      </evsb-card-body>
    </evsb-card>

    <evsb-card [variant]="model.chargeCard ? 'blue' : 'turquoise'" class="mb-12 w-full">
      <evsb-card-header-image
        [variant]="model.chargeCard ? 'blue' : 'turquoise'"
        [label]="'modules.evcSmallBiz.productOverview.chargeCard.title' | translate"
        [imgSrc]="'./assets/evc/img/silver-charging-card.png'"
      >
      </evsb-card-header-image>
      <evsb-smooth-height [trigger]="model.chargeCard">
        <evsb-card-body class="border-b border-grey hidden md:block">
          <ul class="list-checkmark space-y-2">
            <li
              class="mb-3"
              [innerHtml]="'modules.evcSmallBiz.productOverview.chargeCard.point1.title' | translate"
            ></li>
            <li
              class="mb-3"
              [innerHtml]="'modules.evcSmallBiz.productOverview.chargeCard.point2.title' | translate"
            ></li>
            <li
              class="mb-3"
              [innerHtml]="'modules.evcSmallBiz.productOverview.chargeCard.point3.title' | translate"
            ></li>
          </ul>
        </evsb-card-body>
        <evsb-card-body *ngIf="!model.chargeCard">
          <div class="flex justify-between">
            <evsb-currency-md
              [amount]="model.chargeCardPrice"
              [end]="'modules.evcSmallBiz.productOverview.chargeCard.amountEnd' | translate"
              [text]="'modules.evcSmallBiz.productOverview.chargeCard.amountText' | translate"
            ></evsb-currency-md>

            <evsb-secondary-button [size]="btnSmall" class="text-xl" (click)="onAddChargeCard()">
              {{ 'modules.evcSmallBiz.productOverview.chargeCard.cta' | translate }}
            </evsb-secondary-button>
          </div>
        </evsb-card-body>
        <evsb-card-body *ngIf="model.chargeCard">
          <div class="flex mb-4">
            <evsb-currency-md
              [amount]="model.chargeCardPrice"
              [end]="'modules.evcSmallBiz.productOverview.chargeCard.amountEnd' | translate"
              [text]="'modules.evcSmallBiz.productOverview.chargeCard.amountText' | translate"
            >
            </evsb-currency-md>
            <div class="ml-auto flex gap-9">
              <svg-icon
                src="./assets/evsb/icon/trash.svg"
                role="button"
                title="delete"
                class="text-grey"
                (click)="deleteChargeCards()"
              ></svg-icon>
              <svg-icon
                src="./assets/evsb/icon/edit.svg"
                role="button"
                title="edit"
                class="text-primary"
                (click)="editChargeCards()"
              ></svg-icon>
            </div>
          </div>
          <evsb-price-list-entry
            *ngFor="let item of model.chargeCardItems"
            [price]="item.price"
            [count]="item.count"
            [label]="item.label | translate"
          ></evsb-price-list-entry>
        </evsb-card-body>
      </evsb-smooth-height>
    </evsb-card>

    <evsb-card [variant]="model.chargePoint ? 'blue' : 'turquoise'" class="mb-12 w-full">
      <evsb-card-header-image
        [variant]="model.chargePoint ? 'blue' : 'turquoise'"
        [label]="'modules.evcSmallBiz.productOverview.chargePoint.title' | translate"
        [imgSrc]="'./assets/evsb/img/chargerAccess-80x80.png'"
      >
      </evsb-card-header-image>
      <evsb-smooth-height [trigger]="model.chargePoint">
        <evsb-card-body class="border-b border-grey hidden md:block">
          <ul class="list-checkmark space-y-2">
            <li
              class="mb-3"
              [innerHtml]="'modules.evcSmallBiz.productOverview.chargePoint.point1.title' | translate"
            ></li>
            <li
              class="mb-3"
              [innerHtml]="'modules.evcSmallBiz.productOverview.chargePoint.point2.title' | translate"
            ></li>
            <li
              class="mb-3"
              [innerHtml]="'modules.evcSmallBiz.productOverview.chargePoint.point3.title' | translate"
            ></li>
          </ul>
        </evsb-card-body>
        <evsb-card-body *ngIf="!model.chargePoint">
          <div class="flex justify-between">
            <evsb-currency-md
              [amount]="model.chargePointPrice"
              [start]="'modules.evcSmallBiz.productOverview.chargePoint.amountStart' | translate"
              [text]="'modules.evcSmallBiz.productOverview.chargePoint.amountText' | translate"
            ></evsb-currency-md>
            <evsb-secondary-button [size]="btnSmall" class="text-xl" (click)="onAddChargePoint()">
              {{ 'modules.evcSmallBiz.productOverview.chargePoint.cta' | translate }}
            </evsb-secondary-button>
          </div>
        </evsb-card-body>
        <evsb-card-body *ngIf="model.chargePoint">
          <div class="flex mb-4">
            <evsb-currency-md
              [amount]="model.chargePointPrice"
              [text]="'modules.evcSmallBiz.productOverview.chargePoint.amountText' | translate"
            ></evsb-currency-md>
            <div class="ml-auto flex gap-9">
              <svg-icon
                src="./assets/evsb/icon/trash.svg"
                role="button"
                title="delete"
                class="text-grey"
                (click)="deleteChargePoints()"
              ></svg-icon>
              <svg-icon
                src="./assets/evsb/icon/edit.svg"
                role="button"
                title="edit"
                class="text-primary"
                (click)="editChargePoints()"
              ></svg-icon>
            </div>
          </div>
          <evsb-price-list-entry
            class="mb-4 block"
            *ngFor="let item of model.chargePointItems"
            [price]="item.price"
            [count]="item.count"
            [label]="item.label | translate"
          ></evsb-price-list-entry>

          <evsb-media-object
            align="start"
            [src]="'./assets/evc/img/piggybank.svg'"
            class="body-small te-bg-gradient-light-r rounded-lg block overflow-hidden -ml-4 -mr-4 -mb-3"
          >
            {{ 'modules.evcSmallBiz.productOverview.greenEnergy.taxReduction.information' | translate }}
            <button (click)="openGreenEnergyInfoModal()" class="focus:outline-none inline text-blue-600 underline">
              {{ 'modules.evcSmallBiz.productOverview.greenEnergy.taxReduction.learnMore' | translate }}
            </button>
          </evsb-media-object>
        </evsb-card-body>
      </evsb-smooth-height>
    </evsb-card>
  </div>
</div>

<div
  class="
    mt-auto
    z-10
    px-8
    pt-8
    pb-4
    md:pb-32
    bg-white
    flex flex-col
    md:flex-row md:gap-x-16 md:justify-center md:items-center
    sticky
    bottom-0
  "
  *ngIf="model$ | async as model"
>
  <evsb-primary-button
    class="w-full md:w-auto mb-5 md:mb-0 md:order-1"
    (click)="onRequestFinalInvoice()"
    [state]="model.finalInvoiceBtnState"
    [fullWidth]="true"
  >
    {{ 'modules.evcSmallBiz.productOverview.footer.primaryButton' | translate }}
  </evsb-primary-button>
</div>

<ng-template #greenEnergyInfoModal let-modal>
  <evsb-card class="w-screen max-w-lg md:max-w-6xl" [variant]="'turqouise'" [@flyInOut]>
    <evsb-card-header [variant]="'turquoise'">
      <h2 heading class="h4 text-default py-2 md:py-12 md:px-8 flex items-center">
        <div class="rounded-full bg-white w-24 h-24 flex items-center justify-center mr-8 self-center flex-shrink-0">
          <svg-icon [src]="'./assets/evc/img/piggybank.svg'"></svg-icon>
        </div>
        {{ 'modules.evcSmallBiz.productOverview.greenEnergy.taxReduction.title' | translate }}
      </h2>
      <button
        aria-label="Close"
        (click)="modal.dismiss()"
        class="focus:outline-none bg-white rounded-full w-20 h-20 absolute -top-4 -right-4 p-7"
      >
        <svg-icon src="./assets/evc/img/cross.svg" class="text-primary"></svg-icon>
      </button>
    </evsb-card-header>
    <evsb-card-body>
      <div class="flex flex-col md:flex-row md:p-10 md:gap-x-10">
        <p
          class="mb-8 md:w-6/12"
          [innerHtml]="'modules.evcSmallBiz.productOverview.greenEnergy.taxReduction.intro' | translate"
        ></p>
        <evsb-card [variant]="'myDrive'" class="mb-4 md:w-6/12">
          <evsb-card-body>
            <h4 class="h4 te-text-gradient border-b mb-4 pb-4">
              {{ 'modules.evcSmallBiz.productOverview.greenEnergy.taxReduction.item1.title' | translate }}
            </h4>
            <div class="text-grey-dark60 mb-4 body-small">
              {{ 'modules.evcSmallBiz.productOverview.greenEnergy.taxReduction.conditions' | translate }}
            </div>

            <ul class="list-checkmark body-small">
              <li
                class="mb-4"
                [innerHtml]="'modules.evcSmallBiz.productOverview.greenEnergy.taxReduction.item1.item1' | translate"
              ></li>
              <li
                class="mb-4"
                [innerHtml]="'modules.evcSmallBiz.productOverview.greenEnergy.taxReduction.item1.item2' | translate"
              ></li>
              <li
                class="mb-4"
                [innerHtml]="'modules.evcSmallBiz.productOverview.greenEnergy.taxReduction.item1.item3' | translate"
              ></li>
            </ul>
          </evsb-card-body>
        </evsb-card>
      </div>
    </evsb-card-body>
  </evsb-card>
</ng-template>
